import customFetch from '../customFetch';

const API_URL = process.env.VUE_APP_MACHETE_XML_SYNC_API_URL;

const SYNC = `${API_URL}/sync/satws`;

export default {
  async force() {
    const response = await customFetch(SYNC, {
      method: 'POST',
    });

    const { payload } = await response.json();

    return payload;
  },
};
